import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Observable, interval, map, of, startWith, takeWhile } from 'rxjs';
import { Visitor } from 'src/app/models/visitor';

@Component({
  selector: 'app-preapproved-selection-dialog',
  templateUrl: './preapproved-selection-dialog.component.html',
  styleUrl: './preapproved-selection-dialog.component.scss',
})
export class PreapprovedSelectionDialogComponent {
  @Output() onClusterPreApproved = new EventEmitter();
  displayedColumns = ['select', 'no', 'visname', 'hostname', 'security'];
  dataSource: any;
  selection = new SelectionModel<Visitor>(true, []);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Visitor[],
    public dialogRef: MatDialogRef<PreapprovedSelectionDialogComponent>
  ) {
    this.dataSource = new MatTableDataSource<Visitor>(data);
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.dataSource.data);
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: Visitor): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${
      row.visitorID
    }`;
  }
  getExpectedCheckoutTimeNumber(row: any): Observable<number> {
    // Assuming row.checkIn is a valid Date object
    const expectedCheckoutTime = new Date(row.checkIn);
    expectedCheckoutTime.setMinutes(expectedCheckoutTime.getMinutes() + 30);

    return interval(1000) // Emit a value every second
      .pipe(
        startWith(0), // Emit the initial value immediately
        map(() => {
          const currentTime = new Date();
          const timeDifferenceInMilliseconds =
            expectedCheckoutTime.getTime() - currentTime.getTime();
          const timeDifferenceInSeconds = Math.max(
            Math.floor(timeDifferenceInMilliseconds / 1000),
            0
          );

          const minutes = Math.floor(timeDifferenceInSeconds / 60);
          const seconds = timeDifferenceInSeconds % 60;
          return minutes + seconds / 100; // Display seconds as a decimal part of the minute
        }),
        takeWhile((time) => time > 0, true) // Stop emitting when time is less than 0
      );
  }
  getExpectedCheckoutTime(row: any): Observable<string> {
    // Assuming row.checkIn is a valid Date object
    const expectedCheckoutTime = new Date(row.checkIn);
    expectedCheckoutTime.setMinutes(expectedCheckoutTime.getMinutes() + 30);

    const currentTime = new Date();
    const timeDifferenceInMilliseconds =
      expectedCheckoutTime.getTime() - currentTime.getTime();
    const timeDifferenceInSeconds = Math.max(
      Math.floor(timeDifferenceInMilliseconds / 1000),
      0
    );

    const minutes = Math.floor(timeDifferenceInSeconds / 60);
    const seconds = timeDifferenceInSeconds % 60;

    // Format minutes and seconds with leading zeros
    const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
    const formattedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;

    // Display seconds as a decimal part of the minute
    const formattedTime = `${formattedMinutes}:${formattedSeconds}`;

    // Return "minute" or "minutes" based on the value of minutes
    const minuteLabel = minutes === 1 ? 'minute' : 'minutes';
    return of(`${formattedTime} ${minuteLabel}`);
  }
  onClickedCluster() {
    this.onClusterPreApproved.emit(this.selection.selected);
    this.dialogRef.close();
  }
}
